import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AboutPage/index.tsx");
